import { render, staticRenderFns } from "./TabelasPreco.vue?vue&type=template&id=e3fa5cc4"
import script from "./TabelasPreco.vue?vue&type=script&lang=js"
export * from "./TabelasPreco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports